/**
 * View component for /user/on-boarding/:hex
 *
 * Reached from a on-boarding link within an email.  Checks mactch.params.hex
 * against the reset hex for that user in the database.  If valid, allows the
 * user to reach the on-boarding form.  If not, displays "invalid" message
 */

// import form components
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userActions from '../userActions';
import * as userEventActions from '../../userEvent/userEventActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import form components
import { NewPasswordInput, TextInput } from '../../../global/components/forms';

// import user components
import UserLayout from '../components/UserLayout.js.jsx';

class OnBoarding extends Base {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
      , firstName: ''
      , isErrorModalOpen: false
      , lastName: ''
      , password: ''
      , submitting: false
    };
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_toggleErrorModal'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userActions.sendCheckResetHex(match.params.hex));
  }

  _handleFormChange(e) {
    // Only allow names to contain letters, spaces, and hyphens.
    if(e.target.name === 'firstName' || e.target.name === 'lastName') {
      // matches anything that is NOT a letter OR space OR hyphen.
      const pattern = /[^a-z| |-]/gi
      // removes all matches from the string.
      e.target.value = e.target.value.replace(pattern, '') 
    }
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch, history, match } = this.props;
    const { firstName, lastName, password } = this.state;
    let userData = {};
    userData.newPass = password;
    userData.firstName = firstName;
    userData.lastName = lastName;
    // console.log(userData);
    this.setState({submitting: true});
    dispatch(userActions.sendOnBoarding(match.params.hex, userData)).then((action) => {
      this.setState({submitting: false});
      if(action.success) {
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "onboarded"
        }));
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "login"
        }));
        history.push('/');
      } else {
        // console.log("action", action.error)
        dispatch(userActions.sendCheckResetHex(match.params.hex)); // trigger re-check
        this.setState({errorMessage: action.error});
        this._toggleErrorModal();
      }
    });
  }

  _toggleErrorModal() {
    this.setState({isErrorModalOpen: !this.state.isErrorModalOpen});
  }

  render() {
    const { user } = this.props;
    const { firstName, lastName, password, submitting } = this.state;
    let isDisabled = !password;
    return  (
      <UserLayout>
        <div className="yt-container">
          <div className="yt-row center-horiz">
            { user.isFetching ?
                <h3>Loading...</h3>
              :
                <div className="form-container -skinny">
                  { user.resetTokenValid ?
                      <form name="userForm" className="user-form" onSubmit={this._handleFormSubmit}>
                        <img src="/img/logo.png"/>
                        <h2>Setup your account</h2>
                        <h4>Your password must contain at least 8 characters and one each of: uppercase, lowercase, number, and special character.</h4>
                        <hr/>
                        <TextInput
                          change={this._handleFormChange}
                          label="First Name"
                          name="firstName"
                          required={true}
                          value={firstName}
                        />
                        <TextInput
                          change={this._handleFormChange}
                          label="Last Name"
                          name="lastName"
                          required={true}
                          value={lastName}
                        />
                        <NewPasswordInput
                          change={this._handleFormChange}
                          name="password"
                          value={password}
                        />
                        <div className="input-group">
                          <div className="yt-row right">
                            <Link to={"/user/login"} className="yt-btn link"> Back To Login </Link>
                            <button className="yt-btn slate" type="submit" disabled={isDisabled || submitting}>
                              { submitting ?
                                  <span>Sending...</span>
                                :
                                  <span>Register </span>
                              }
                            </button>
                          </div>
                        </div>
                      </form>
                    :
                      <div className="card">
                        <div className="card-header">
                          <h2>Something wrong!</h2>
                        </div>
                        <div className="card-body">
                          <p>Sorry, the link we sent you has expired. As a security measure, all on-boarding links are only valid for 7 days.</p>
                          <br/>
                          <p>Please visit the <Link to="/user/forgot-password">password recovery page</Link> to receive a new password reset link.</p>
                          <br/>
                          <p>If you continue to have difficulty, please contact: <a href="mailto:prosupport@simulations-plus.com">prosupport@simulations-plus.com</a> and we will send a new onboarding email. </p>
                          <hr/>
                          <Link to={"/user/forgot-password"} className="yt-btn small block"><i className="fa fa-angle-double-left" /> Request Password Reset </Link>
                        </div>

                      </div>
                  }
                </div>
            }
          </div>
          <AlertModal
            alertMessage={
              <div>
                <strong>
                  {this.state.errorMessage}
                </strong>
                <br/>
                <div>Please try again.</div>
              </div>
            }
            alertTitle="Error"
            closeAction={this._toggleErrorModal}
            confirmAction={this._toggleErrorModal}
            confirmText="Try again"
            isOpen={this.state.isErrorModalOpen}
            type="danger"
          />
        </div>
      </UserLayout>
    )
  }
}

OnBoarding.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return { user: store.user.loggedIn }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(OnBoarding)
);



// WEBPACK FOOTER //
// modules/user/views/OnBoarding.js.jsx